// extracted by mini-css-extract-plugin
module.exports = {"newArrivalsHeader":"NewArrivalsHeader-module__newArrivalsHeader","newArrivalsDescription":"NewArrivalsHeader-module__newArrivalsDescription"};